// extracted by mini-css-extract-plugin
export var divider = "_fp-7";
export var itemsToggle = "_fp-8";
export var mergeModal = "_fp-1";
export var optionCard = "_fp-4";
export var radioGroup = "_fp-6";
export var radioOption = "_fp-0";
export var selected = "_fp-5";
export var shipmentOptions = "_fp-2";
export var tableOptions = "_fp-3";